import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import ChuGiaiApi from '../../api/ChuGiaiApi';


export const SelectDoDoc = (props) => {

    const [listDks, setDk] = useState([]);
    const [selectedOption, setSelectedOption] = useState();

    useEffect(() => {

        loadDkTuoi();

    }, []);


    const loadDkTuoi = () => {
        ChuGiaiApi.getAllDvdd().then((response) => {
            let list = [];
            list.push({ value: '', label: 'Chọn đk độ dốc' });
            response.listDocs.forEach(item => {
                list.push({ value: item.maDodoc, label: item.PhanCap });

                if (list.length > 0) {
                    const index = list.findIndex(x => x.value == props.Ma);

                    if (index != -1) {
                        setSelectedOption(list[index]);
                        props.onChangeDocProps(list[index]);
                    }
                }
            });
            setDk(list);
        })
    }

    const onChangeDoDoc = (e) => {
        setSelectedOption(e);
        props.onChangeDocProps(e);
    }

    return (
        <Select
            className="select"
            name="Xa"
            placeholder="Chọn đk độ dốc"
            value={selectedOption}
            onChange={onChangeDoDoc}
            options={listDks}
            theme={theme => ({
                ...theme,
                borderRadius: 0,
                height: 30,
                spacing: {
                    controlHeight: 30,
                    menuGutter: 1,
                    baseUnit: 2,
                }
            })}
        />
    )
}
